/*
  Ralph Karouni - scroll reveal
  Adds .is-visible to .rk-reveal elements as they enter the viewport.
  Restraint over spectacle: a single subtle fade + rise (see rk-brand.css).
*/
(function () {
  /* Tells the failsafe timer in layout/theme.liquid that the reveal system is
     alive, so it leaves html.rk-js in place. If this file never loads, that timer
     drops the class and every .rk-reveal becomes visible instead of staying blank. */
  window.RKRevealReady = true;

  function init() {
    var els = document.querySelectorAll('.rk-reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      /* Reveal as soon as any part of the element comes within 15% of the
         bottom edge. The old 0.15 threshold with a negative margin left tall
         phone blocks (gem grid cells, 4:5 banners) black while their top edge
         was already on screen, which read as "the next picture is not loading". */
      { rootMargin: '0px 0px 15% 0px', threshold: 0 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
